var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("TitleBar"), _c("div", {
    staticClass: "main"
  }, [_c("div", {
    staticClass: "input-con"
  }, [_c("van-search", {
    ref: "inputs",
    attrs: {
      maxlength: "50",
      type: "text",
      placeholder: _vm.$t("Search")
    },
    on: {
      input: function input($event) {
        $event.stopPropagation();
        return _vm.input(_vm.value);
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEmpty,
      expression: "!isEmpty"
    }],
    staticClass: "clear-icon",
    on: {
      click: _vm.clear
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/close.png"),
      alt: ""
    }
  })]), _c("div", {
    class: ["search", {
      black: _vm.highLight
    }],
    on: {
      click: function click($event) {
        return _vm.getResult(_vm.value);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Search")))])], 1), _vm.isResults ? _c("div", {
    staticClass: "results"
  }, [_c("van-tabs", {
    ref: "tabs",
    attrs: {
      background: "#fff",
      "title-active-color": "rgba(0,0,0)",
      "title-inactive-color": "rgba(0,0,0,0.60)",
      swipeable: ""
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_vm._l(_vm.arr, function (item) {
    return _c("van-tab", {
      key: item,
      attrs: {
        title: _vm.$t(item),
        name: item
      }
    });
  }), _c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_c("router-view", {
    staticClass: "Router",
    attrs: {
      inputValue: _vm.inputValue
    },
    on: {
      tabChange: _vm.tabChange
    }
  })], 1)], 2)], 1) : _vm._e(), _vm.findList.length > 0 ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isInput && !_vm.isResults,
      expression: "isInput && !isResults"
    }],
    staticClass: "menu-list"
  }, _vm._l(_vm.findList, function (item) {
    return _c("span", {
      key: item,
      on: {
        click: function click($event) {
          return _vm.getResult(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _vm._e(), _vm.historySearchList.length > 0 ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("RecentSearches")))]), _c("div", {
    on: {
      click: _vm.clearHistory
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/ic_search_delete_normal.png"),
      alt: ""
    }
  })])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.historySearchList, function (item) {
    return _c("span", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.getResult(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0)]) : _vm._e(), _vm.hotSearchList.length > 0 ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("HotSearches")))])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.hotSearchList, function (item) {
    return _c("span", {
      key: item.bkId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.getResult(item.keyword);
        }
      }
    }, [_vm._v(_vm._s(item.keyword))]);
  }), 0)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("HotTopic")))]), _c("div", {
    staticClass: "more",
    on: {
      click: _vm.toAllTopic
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "12px",
      color: "rgba(0, 0, 0, 0.32)"
    }
  }, [_vm._v(_vm._s(_vm.$t("AllTopics")))]), _c("img", {
    attrs: {
      src: require("../../../assets/images/ic_common_next.png"),
      alt: ""
    }
  })])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.hotTopicList, function (item) {
    return _c("span", {
      key: item.topicId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toTopic(item.topicId);
        }
      }
    }, [_vm._v(_vm._s(item.content))]);
  }), 0)])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };